const credentials = module.exports = {
  googleSheet: "https://sheet.best/api/sheets/752bd80d-932a-496e-a5cc-1a7edaef72d2"
};
